import React, { useState } from 'react';
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
  FormControl,
} from '@mui/material';
import { Send } from '@mui/icons-material';
import QRCode from 'qrcode';

interface LinkToQRProps {
  onQRGenerated: (imageUrl: string) => void;
}

const LinkToQR: React.FC<LinkToQRProps> = ({ onQRGenerated }) => {
  const [linkUrl, setLinkUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError(null);

      // Basic URL validation
      try {
        new URL(linkUrl);
      } catch (e) {
        throw new Error('Por favor, introduce una URL válida');
      }

      // Generate QR code as data URL
      const qrDataUrl = await QRCode.toDataURL(linkUrl, {
        errorCorrectionLevel: 'H',
        margin: 1,
        width: 300,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });
      
      onQRGenerated(qrDataUrl);
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Error al generar el QR');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Link a QR
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <TextField
          label="URL"
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          placeholder="https://ejemplo.com"
          required
          error={!!error}
          helperText={error}
        />
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleSubmit}
        disabled={loading || !linkUrl}
        startIcon={loading ? <CircularProgress size={20} /> : <Send />}
        fullWidth
      >
        {loading ? 'Generando...' : 'Generar QR'}
      </Button>
    </>
  );
};

export default LinkToQR; 